import React from "react";
import { Box, Text } from "@chakra-ui/react";
import TurnstileV2 from "components/turnstile-v2/TurnstileV2";

import Logo from "components/Logo";

interface AuthLayoutProps {
  children: React.ReactNode;
}
export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100vh"
      bg="gray.50"
    >
      <Box transform={"scale(1.75)"} mb={4}>
        <Logo />
      </Box>
      <Box maxW="380px">
        <Box width="100%" p={10}>
          <TurnstileV2>{children}</TurnstileV2>
        </Box>
        <Text fontSize="xs" color="gray.500" mt={4} textAlign="center">
          Property Technology Ltd (SC528448) is registered in the United
          Kingdom. Property Technology Ltd, 70 White Lion Street, London, N1
          9PP.
        </Text>
      </Box>
    </Box>
  );
};
